import React from "react";
import { useNavigate } from "react-router-dom";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// reactstrap components
import {
  Breadcrumb,
  BreadcrumbItem,
  Card,
  CardBody,
  CardTitle,
  Container,
  Row,
  Col,
} from "reactstrap";
import "assets/css/custom.css";
import { useTranslation } from "context/TranslationProvider";


function CardsHeader({ name, parentName,  totalUsers = 0, totalOrders = 0, totalListings = 0, completedOrders = 0,  routes = {}, ...props }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <>
      <div className="header d-flex overflow-hidden">
        <Container fluid>
          <div className="header-body">
            <Row className="align-items-center py-4">
              <Col lg="6" xs="7">
                <h6 className="fullcalendar-title h2 text-orange d-inline-block mb-0">
                  {name}
                </h6>{" "}
                <Breadcrumb
                  className="d-none d-md-inline-block ml-md-4 text-info"
                  listClassName="breadcrumb-links breadcrumb-dark"
                >
                  <BreadcrumbItem className=" text-orange">
                    <a href="/" className="breadcrumb-link" onClick={(e) => e.preventDefault()} >
                      <i className="fas fa-home text-orange" />
                    </a>
                  </BreadcrumbItem>
                  <BreadcrumbItem className="text-orange">
                    <a href="/" className="breadcrumb-link" onClick={(e) => e.preventDefault()}>
                      <span className="text-orange">{parentName}</span>
                    </a>
                  </BreadcrumbItem>
                </Breadcrumb>
              </Col>
            </Row>

            <Row className="align-items-stretch">
              <Col md="6" xl="3" className="mb-4 mb-xl-0 d-flex">
                <Card className="card-stats w-100 cursor-pointer" onClick={() => routes.totalUsers && navigate(routes.totalUsers)}>
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          tag="h5"
                          className="text-uppercase text-muted mb-0 card-title card-title-wrap"
                        >
                          {t("analytics.dashboard.totalUsers", "Total Users")}
                        </CardTitle>
                        <span className="h2 font-weight-bold mb-0">
                          {totalUsers ?? 0}
                        </span>
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-gradient-red text-white rounded-circle shadow">
                          <i className="fa fa-user" />
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
              <Col md="6" xl="3" className="mb-4 mb-xl-0 d-flex">
                <Card className="card-stats w-100 cursor-pointer" onClick={() => routes.totalOrders && navigate(routes.totalOrders)}>
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          tag="h5"
                          className="text-uppercase text-muted mb-0 card-title card-title-wrap"
                        >
                          {t("analytics.dashboard.totalOrders", "Total Orders")}
                        </CardTitle>
                        <span className="h2 font-weight-bold mb-0">{totalOrders ?? 0}</span>
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-gradient-orange text-white rounded-circle shadow">
                          <i className="ni ni-basket" />
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
              <Col md="6" xl="3" className="mb-4 mb-xl-0 d-flex" >
                <Card className="card-stats w-100 cursor-pointer" onClick={() => routes.totalListings && navigate(routes.totalListings)}>
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          tag="h5"
                          className="text-uppercase text-muted mb-0 card-title card-title-wrap"
                        >
                          {t("analytics.dashboard.allListings", "All Listings")}
                        </CardTitle>
                        <span className="h2 font-weight-bold mb-0">{totalListings ?? 0}</span>
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-gradient-green text-white rounded-circle shadow">
                          <i className="ni ni-bullet-list-67" />
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
              <Col md="6" xl="3" className="mb-4 mb-xl-0 d-flex">
                <Card className="card-stats w-100 cursor-pointer" onClick={() => routes.completedOrders && navigate(routes.completedOrders)}>
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          tag="h5"
                          className="text-uppercase text-muted mb-0 card-title card-title-wrap"
                        >
                          {t("analytics.dashboard.completedOrders", "Completed Orders")}
                        </CardTitle>
                        <span className="h2 font-weight-bold mb-0">{completedOrders ?? 0}</span>
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-gradient-primary text-white rounded-circle shadow">
                          <i className="ni ni-check-bold" />
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
}

CardsHeader.propTypes = {
  name: PropTypes.string,
  parentName: PropTypes.string,
  totalUsers: PropTypes.number,
  totalOrders: PropTypes.number,
  totalListings: PropTypes.number,
  completedOrders: PropTypes.number,
};

export default CardsHeader;
